import React from 'react';
import { withSize } from 'react-sizeme';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import {
    Calculator,
    CircleSpinner,
    MessageBanner,
    MessageBannerVariants,
} from '@ratehub/base-ui';

import getScenarioCount from '../functions/getScenarioCount';
import DownPaymentCalculatorScenarioStep from './DownPaymentCalculatorScenarioStep';


function DownPaymentCalculator({
    size,
    messageBannerProps,
    ctaHref,
    ctaLabel,
    calculatorTitle,
    ...otherProps
}) {
    const scenarioCount = getScenarioCount(size?.width);
    const isMessageBannerCTAEnabled = !!(messageBannerProps?.title || messageBannerProps?.message);

    const DEFAULT_TITLE = (
        <FormattedMessage
            id="mtg-calculator.DownPaymentCalculator.calculatorTitle"
            defaultMessage="Ratehub.ca's mortgage down payment calculator"
        />
    );
    
    return (
        <StyledCalculator 
            title={
                calculatorTitle
                    ? calculatorTitle 
                    : DEFAULT_TITLE
            }
            {...otherProps}
        >
            <If condition={!size.width}>
                <CircleSpinner />
            </If>

            <If condition={scenarioCount}>
                <DownPaymentCalculatorScenarioStep
                    stepNumber={1}
                    scenarioCount={scenarioCount}
                />
            </If>
            <If condition={isMessageBannerCTAEnabled}>
                <MessageBanner
                    className="messsageBanner"
                    variant={MessageBannerVariants.NOTIFICATION}

                    {...messageBannerProps}
                    messageSize="small"

                    ctaMessage={ctaLabel}
                    ctaDataName="mtg-DownPaymentCalculator-learnMore"
                    ctaVariant="primaryAnchor"
                    href={ctaHref}
                />
            </If>
        </StyledCalculator>
    );
}

DownPaymentCalculator.propTypes = {
    size: PropTypes.object.isRequired,
    messageBannerProps: PropTypes.object,
    ctaHref: PropTypes.string,
    ctaLabel: PropTypes.string,
    calculatorTitle: PropTypes.string,
};

DownPaymentCalculator.defaultProps = {
    messageBannerProps: undefined,
    ctaHref: undefined,
    ctaLabel: undefined,
    calculatorTitle: undefined,
};

const StyledCalculator = styled(Calculator)`
    max-width: 70rem; //1120px
`;

export default withSize({ noPlaceholder: true })(observer(DownPaymentCalculator));
